import { IconTooltip } from 'sonata-react-components';

import type { CSSProperties, ReactNode } from 'react';

type Props = {
  /** Omitted by the blocks that sit on the right of a card divider, which carry no icon. */
  icon?: {
    className: string;
    color: string;
    containerStyle: CSSProperties;
  };
  value: string;
  label: string;
  tooltip?: ReactNode;
  caption?: string;
  /** Rendered under the caption, e.g. a "Learn more…" link. */
  footer?: ReactNode;
};

/**
 * Value, label and caption of a single metric, optionally preceded by its
 * gradient icon: the building block every detail card is made of. The info
 * tooltip sits next to the value, as in the design.
 */
export default function MetricBlock({ icon, value, label, tooltip, caption, footer }: Readonly<Props>) {
  return (
    <div className="metricDetailCards__block">
      {icon && (
        <div className="metricDetailCards__blockIcon" style={icon.containerStyle}>
          <i className={icon.className} style={{ color: icon.color }} />
        </div>
      )}
      <div className="metricDetailCards__blockTexts">
        <div className="metricDetailCards__valueRow">
          <span className="metricDetailCards__value">{value}</span>
          {tooltip && (
            <IconTooltip
              icon="fa-regular fa-circle-info"
              iconColor="var(--color-sonata-primary-500, #7B9FE1) !important"
              place="top"
            >
              {tooltip}
            </IconTooltip>
          )}
        </div>
        <div className="metricDetailCards__labelRow">
          <span className="metricDetailCards__label">{label}</span>
        </div>
        {caption && <span className="metricDetailCards__caption">{caption}</span>}
        {footer}
      </div>
    </div>
  );
}
